import { ErrorMessage } from './index'

export default () => {
  return <ErrorMessage message="An error has occurred" />
}
